import type { TOC } from '@ember/component/template-only'
import { BookLibraryBookDetailPairs } from 'teacher-ui-client/components/book-library/book-detail-pairs'
import { t } from 'ember-intl'
import joinList from 'teacher-ui-client/helpers/join-list'
import type BookLibraryBook from 'teacher-ui-client/models/book-library/book'

interface Args {
  book: BookLibraryBook
}

interface Signature {
  Args: Args
  Element: HTMLElement
}
export const BookModalBookDetails: TOC<Signature> = <template>
  <section ...attributes>
    <h3 class="mb-3">
      {{@book.title}}
    </h3>
    <div class="flex justify-between gap-3">
      <dl class="w-1/2 space-y-3">
        <div>
          <dt class="text-dusty-black-250 float-left clear-left pr-3 uppercase">
            {{t "bookLibrary.bookAttr.primaryCategories"}}
          </dt>
          <dd class="pl-2">
            {{joinList @book.formattedPrimaryCategories ", "}}
          </dd>
        </div>
        <div>
          <dt class="text-dusty-black-250 float-left clear-left pr-3 uppercase">
            {{t "bookLibrary.bookAttr.pages"}}
          </dt>
          <dd>
            {{@book.pages}}
          </dd>
        </div>
        <div>
          <dt class="text-dusty-black-250 float-left clear-left pr-3 uppercase">
            {{t "bookLibrary.bookAttr.wordCount"}}
          </dt>
          <dd>
            {{@book.wordCount}}
          </dd>
        </div>
        <div>
          <dt class="text-dusty-black-250 float-left clear-left pr-3 uppercase">
            {{t "bookLibrary.bookAttr.metaData.blakeReadingLevel.name"}}
          </dt>
          <dd>
            {{t "bookLibrary.bookAttr.metaData.blakeReadingLevel.value" value=@book.bookMetadata.blakeReadingLevel}}
          </dd>
        </div>
        <div>
          <dt class="text-dusty-black-250 float-left clear-left pr-3 uppercase">
            {{t "bookLibrary.bookAttr.classification"}}
          </dt>
          <dd>
            {{@book.formattedClassification}}
          </dd>
        </div>
        <div>
          <dt class="text-dusty-black-250 float-left clear-left pr-3 uppercase">
            {{t "bookLibrary.bookAttr.audio"}}
          </dt>
          <dd>
            {{@book.formattedAudio}}
          </dd>
        </div>
      </dl>
      <dl class="w-1/2 space-y-3">
        <BookLibraryBookDetailPairs @book={{@book}} as |bookDetailNameValuePairs|>
          {{#each bookDetailNameValuePairs as |bookDetailPair|}}
            <div>
              <dt class="text-dusty-black-250 float-left clear-left pr-3 uppercase">
                {{bookDetailPair.name}}
              </dt>
              <dd>
                {{bookDetailPair.value}}
              </dd>
            </div>
          {{/each}}
        </BookLibraryBookDetailPairs>
      </dl>
    </div>
  </section>
</template>

export default BookModalBookDetails
